import LoadingDots from "@components/_Layout/Loaders/LoadingDots";
import PropTypes from "prop-types";
import React from "react";
import Select, {
  GroupBase,
  LoadingIndicatorProps,
  OptionsOrGroups,
} from "react-select";
import { SelectOptionType } from "../../../../types";
import { StateManagerProps } from "react-select/dist/declarations/src/stateManager";
import { useConfig } from "@hooks";

interface AdvancedSelectProps extends StateManagerProps {
  options: OptionsOrGroups<unknown, GroupBase<unknown>> | SelectOptionType[];
}

const AdvancedSelect: React.FC<AdvancedSelectProps> = ({ ...props }) => {
  const { mode: clientMode } = useConfig();
  const mode = clientMode ? clientMode : "vacanceole";
  const themeColor = mode === "vacanceole" ? "#2A56EC" : "#008696";
  const themeColorLight = mode === "vacanceole" ? "#dbfff7" : "#dcf2f7";

  return (
    <>
      <Select
        className={`${props.isMulti ? "basic-multi-select" : "basic-select"}`}
        {...props}
        styles={{
          control: (provided, state) => ({
            ...provided,
            boxShadow: "none",
            padding: "0.125rem 0.5rem",
            borderRadius: "9999px",
            borderColor: state.isFocused ? themeColor : "#d1d5db",
            fontFamily: "Montserrat",
            ":hover": {
              borderColor: themeColor,
            },
          }),
          placeholder: (provided) => ({
            ...provided,
            color: themeColor,
          }),
          singleValue: (provided) => ({
            ...provided,
            color: themeColor,
          }),
          option: (base, { isFocused, isSelected }) => ({
            ...base,
            color: isSelected ? "#ffffff" : undefined,
            background: isSelected
              ? themeColor
              : isFocused
                ? themeColorLight
                : undefined,
            ":active": {
              ...base[":active"],
              background: themeColor,
            },
          }),
        }}
        classNamePrefix="react-select"
        components={{ LoadingIndicator }}
        value={props.options.length === 1 ? props.options[0] : props.value}
      />
    </>
  );
};

//Loading Indicator overwrite
const LoadingIndicator = (props: LoadingIndicatorProps<any>) => {
  return (
    <div className="tw-flex tw-mx-2">
      <LoadingDots />
    </div>
  );
};

AdvancedSelect.propTypes = {
  options: PropTypes.array.isRequired,
};

export default AdvancedSelect;
